<template>

  <div>
    <ul class="list-group">
      <li 
        class="list-group-item" 
        v-for="(rating, index) in questionRatings"
        :key="index">
        <div style="white-space: pre-wrap;"><i>{{ rating.comment }}</i></div>
        <div class="text-muted mb-2">por {{ rating.author_user_id.name }}</div>
        <star-rating
          v-model="rating.rating"
          :star-size="20"
          :read-only="true"
          :show-rating="false">
          </star-rating>
      </li>
    </ul>

    <div
      class="mt-3"
      v-if="permissions.includes('manage_candidates')">
      <button
        v-if="!value"
        class="btn btn-sm btn-light"
        @click="editRating(myQuestionRating)">
        <i class="fas fa-star" /> {{ $t('Add review') }}
        </button>

      <div
        v-if="value">
        <div class="form-group">
          <textarea
            class="form-control mb-2"
            v-model="value.comment"
            :placeholder="$t('Comment')">
            </textarea>
          <ValidateMessage
            :error="validateErrors.comment" />
          <star-rating
            v-model="value.rating"
            :star-size="20"
            :show-rating="false">
            </star-rating>
          <ValidateMessage
            :error="validateErrors.rating" />
        </div>

        <div :class="{'box-loading': loading}">
          <button
            type="submit"
            class="btn btn-primary"
            @click="saveRating(value)">
            {{ $t('Save') }}
            </button>
          <button
            type="submit"
            class="btn btn-light"
            @click="cancelRating()">
            {{ $t('Cancel') }}
            </button>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import StarRating from 'vue-star-rating'

export default {
  name: 'CandidateFeedIntervideoItem',
  components: {
    StarRating
  },
  props: [
    'intervideo_id',
    'question_id',
    'ratings'
  ],
  data () {
    return {
      loading: false,
      validateErrors: false,
      value: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    questionRatings () {
      return this.ratings.filter((v) => {
        return v.question_id === this.question_id
      })
    },
    myQuestionRating () {
      return this.questionRatings.filter((v) => {
        return v.author_user_id._id === this.$store.getters.getMe._id
      })[0] || {}
    }
  },
  created () {
  },
  methods: {
    saveRating (value) {
      this.loading = true

      value.intervideo_id = this.intervideo_id
      value.question_id = this.question_id

      this.$store
      .dispatch('createIntervideoRating', value)
      .then((result) => {
        this.loading = false
        this.value = false
        this.$emit('updated', result)
      })
    },
    editRating (value) {
      this.value = this.$clone(value)
    },
    cancelRating () {
      this.value = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Feed/CandidateFeedIntervideoItemRating.vue